module.exports = __webpack_public_path__ + "img/a890bcd.png";